import { NgModule } from '@angular/core';
import { ioteqScrollbarDirective } from '@tools/directives/scrollbar/scrollbar.directive';

@NgModule({
    declarations: [
        ioteqScrollbarDirective
    ],
    exports     : [
        ioteqScrollbarDirective
    ]
})
export class ioteqScrollbarModule
{
}
